import axios from "axios";
import hexRgb from "hex-rgb";
import Global from "../../global";
import InPlayer from "../backend/inplayer";

//import InPlayer from '../backend/inplayer';
/* import Global from "../../global"; */

//const jwt = require('jsonwebtoken');
//const Time = new Date();

/* 
function jwt_signed_url(API_SECRET,path, host = 'https://cdn.jwplayer.com') {
    const token = jwt.sign(
        {
            exp: Math.ceil((Time.getTime() + 3600) / 300) * 300,
            resource: path,
        },
        API_SECRET
    );

    return `${host}${path}?token=${token}`;
}
 */

//Environment Variable

export const getapiurl = () => {
  return process.env.NODE_ENV === "development"
    ? process.env.REACT_APP_DEV_API_URL
    : process.env.REACT_APP_PROD_API_URL;
};

export const getShareurl = (type, url, image, title, appid, pageid) => {
  return (
    process.env.REACT_APP_SHARE_DEV_URL +
    "?type=" +
    type +
    "&title=" +
    title +
    "&appid=" +
    appid +
    "&id=" +
    pageid +
    "&image=" +
    image +
    "&url=" +
    url
  );
};

export const getAccessToken = async (id) => {
  const api_url = getapiurl() + "api/view/" + id + "/accessToken";
  const token = getLocalToken();
  if (!token) {
    const resp = await axios
      .post(api_url)
      .then((response) => {
        // If request is good...

        return response;
      })
      .catch((error) => {
        throw error;
      });
    setTokenSession(resp.data);
    return resp.data;
  } else {
    return token;
  }
};

export const saveDetail = (ref, arr) => {
  localStorage.setItem(ref, JSON.stringify(arr));
};

export const getLocalToken = () => {
  return localStorage.getItem("prev_tk") || null;
};
export const setTokenSession = (token) => {
  localStorage.setItem("prev_tk", token);
};

export const setOtpSession = (token) => {
  localStorage.setItem("2f_session", token);
};
export const getOtpSession = () => {
  return localStorage.getItem("2f_session") || null;
};

export const setTokenSetting = (token) => {
  localStorage.setItem("prev_tk", token);
};
export const getColor = async (id) => {
  const api_url = getapiurl() + "api/view/" + id + "/getColor";
  const token = await getAccessToken(id);

  const resp = await axios
    .get(api_url, { headers: { Authorization: token } })
    .then((response) => {
      // If request is good...

      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const getAppId = (id) => {
  return id;
};

export const getMenu = async (id) => {
  const api_url = getapiurl() + "api/view/" + id + "/getMenu";
  const token = await getAccessToken(id);

  const resp = await axios
    .get(api_url, { headers: { Authorization: token } })
    .then((response) => {
      // If request is good...

      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const getLanguageJSON = async (id) => {
  const api_url = id;

  const resp = await axios
    .get(api_url)
    .then((response) => {
      // If request is good...

      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const rgba = (hex, alpha) => {
  const rgb = hexRgb(hex, { format: "array" }).slice(0, -1).join(",");
  return `${rgb},${alpha}`;
};

export const getApiSetup = async (id) => {
  const api_url = getapiurl() + "api/view/" + id + "/getAppSetup";
  const token = await getAccessToken(id);

  const resp = await axios
    .get(api_url, { headers: { Authorization: token } })
    .then((response) => {
      // If request is good...

      return response;
    })
    .catch((error) => {
      if (error.response.data === "Invalid Token") {
        throw error;
      } else {
        throw error;
      }
    });
  return resp;
};

export const renewToken = async (id) => {
  const api_url = getapiurl() + "api/view/" + id + "/accessToken";
  /* eslint-disable no-unused-vars */
  const resp = await axios
    .post(api_url)
    .then((response) => {
      // If request is good...

      setTokenSession(response.data);
    })
    .catch((error) => {
      throw error;
    });

  return resp;
};

export const getAWSUrl = () => {
  return "https://smottstorage.s3.us-east-2.amazonaws.com/";
};

export const getImagesById = async (key) => {
  const url = getapiurl();
  const aws = "api/aws/";
  const requestName = "/getImage";
  const getUrl = url + aws + key + requestName;

  const resp = await axios
    .get(getUrl)
    .then((response) => {
      // If request is good...

      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const getPageDetails = async (app, id) => {
  const api_url =
    getapiurl() + "api/view/" + id + "/" + app + "/getUrlPageItem";
  const token = await getAccessToken(app);

  const resp = await axios
    .get(api_url, { headers: { Authorization: token } })
    .then((response) => {
      // If request is good...

      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const hexToRgb = (hex) => {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (result) {
    var r = parseInt(result[1], 16);
    var g = parseInt(result[2], 16);
    var b = parseInt(result[3], 16);
    return r + "," + g + "," + b; //return 23,14,45 -> reformat if needed
  }
  return null;
};

export const getFullURLDetails = async (app, id, skip, limit) => {
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();
  const api_url =
    getapiurl() +
    "api/view/" +
    id +
    "/" +
    app +
    "/getUrlFullItem?limit=" +
    limit +
    "&skip=" +
    skip;
  const token = await getAccessToken(app);

  const resp = await axios
    .get(api_url, { headers: { Authorization: token } })
    .then((response) => {
      // If request is good...

      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const getFullPageItem = async (app, id, skip, limit) => {
  const api_url =
    getapiurl() +
    "api/view/" +
    app +
    "/" +
    id +
    "/getPageFullItem?limit=" +
    limit +
    "&skip=" +
    skip;
  const token = await getAccessToken(app);

  const resp = await axios
    .get(api_url, { headers: { Authorization: token } })
    .then((response) => {
      // If request is good...

      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const getElemDetails = async (app, id) => {
  const api_url = getapiurl() + "api/view/" + id + "/getElemFullDetail";
  const token = await getAccessToken(app);

  const resp = await axios
    .get(api_url, { headers: { Authorization: token } })
    .then((response) => {
      // If request is good...

      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const getPlaylist = async (key, limit) => {
  const url = getVCMSAPI();
  const aws = "playlists/";
  const requestName = "/getPlaylist";
  const getUrl = url + aws + key + "?poster_width=1920&page_limit=" + limit;

  const resp = await axios
    .get(getUrl)
    .then((response) => {
      // If request is good...

      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const getYoutubePlaylist = async (
  id,
  limit,
  api_key = Global.JWAPIKEYV1
) => {
  const url = getYoutubeAPI();
  const aws = "playlistItems";
  const getUrl =
    url +
    aws +
    "?key=" +
    api_key +
    "&playlistId=" +
    id +
    "&maxResults=" +
    limit +
    "&part=snippet&part=id&part=contentDetails";
  const resp = await axios
    .get(getUrl)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const getYoutubeRecommPlaylist = async (api_key = Global.JWAPIKEYV1) => {
  let id = Global.JWAPIKEYV3;
  let limit = 7;
  const url = getYoutubeAPI();
  const aws = "playlistItems";
  const getUrl =
    url +
    aws +
    "?key=" +
    api_key +
    "&playlistId=" +
    id +
    "&maxResults=" +
    limit +
    "&part=snippet&part=id&part=contentDetails";

  const resp = await axios
    .get(getUrl)
    .then((response) => {
      // If request is good...

      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const getRecommended = async (key, limit, mediaid, offset) => {
  const url = getVCMSAPI();
  const aws = "playlists/";
  //const requestName="/getPlaylist";
  const getUrl =
    url +
    aws +
    key +
    "?poster_width=1920&related_media_id=" +
    mediaid +
    "&page_limit=" +
    limit +
    "&page_offset=" +
    offset;

  const resp = await axios
    .get(getUrl)
    .then((response) => {
      // If request is good...

      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const getWatchPlaylist = async (key, mediaid) => {
  const url =
    "https://cdn.jwplayer.com/apps/watchlists/" + key + "?media_ids=" + mediaid;

  //const requestName="/getPlaylist";
  const getUrl = url;

  const resp = await axios
    .get(getUrl)
    .then((response) => {
      // If request is good...

      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const setWatchString = (arr) => {
  let str = "";
  let index = 1;
  let length = arr.length;
  arr.forEach((element) => {
    if (index < length) {
      str = str + element.video_id + ",";
    } else {
      str = str + element.video_id;
    }
    index++;
    /* ... */
  });
  return str;
};

export const getSearchPlaylist = async (key, search) => {
  const url = getVCMSAPI();
  const aws = "playlists/";
  const requestName = "/getPlaylist";
  const getUrl = url + aws + key + "?search=" + search;

  const resp = await axios
    .get(getUrl)
    .then((response) => {
      // If request is good...

      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const getYoutubeSearchPlaylist = async (
  id,
  limit,
  query,
  api_key = Global.JWAPIKEYV1
) => {
  const url = getYoutubeAPI();
  const aws = "search";
  const getUrl =
    url +
    aws +
    "?key=" +
    api_key +
    "&channelId=" +
    id +
    "&maxResults=" +
    limit +
    "&q=" +
    query +
    "&part=snippet";

  const resp = await axios
    .get(getUrl)
    .then((response) => {
      // If request is good...

      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const getFullPageDetails = async (app, id) => {
  const api_url = getapiurl() + "api/view/" + id + "/getFullPageDetails";
  const token = await getAccessToken(app);

  const resp = await axios
    .get(api_url, { headers: { Authorization: token } })
    .then((response) => {
      // If request is good...

      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const getVCMSAPI = () => {
  return "https://cdn.jwplayer.com/v2/";
};

export const getYoutubeAPI = () => {
  return "https://www.googleapis.com/youtube/v3/";
};

export const getVideo = async (key, limit) => {
  const url = getVCMSAPI();
  const aws = "media/";
  const getUrl = url + aws + key + "?poster_width=1920";

  const resp = await axios
    .get(getUrl)
    .then((response) => {
      // If request is good...

      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const getYoutubeVideo = async (id, api_key = Global.JWAPIKEYV1) => {
  const url = getYoutubeAPI();
  const aws = "videos";
  const getUrl =
    url +
    aws +
    "?part=snippet%2CcontentDetails%2Cstatistics&id=" +
    id +
    "&key=" +
    api_key;

  const resp = await axios
    .get(getUrl)
    .then((response) => {
      // If request is good...

      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const getVideoDescription = async (key) => {
  const url = getapiurl();
  const aws = "api/view/";
  const requestName = "/getVideo";
  const getUrl = url + aws + key + requestName;

  const resp = await axios
    .get(getUrl)
    .then((response) => {
      // If request is good...

      return response.data.ShortDescription;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const getLastPage = async (app, id) => {
  const api_url = getapiurl() + "api/view/" + id + "/getLastPage";
  const token = await getAccessToken(app);

  const resp = await axios
    .get(api_url, { headers: { Authorization: token } })
    .then((response) => {
      // If request is good...

      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const getFullPage = async (app, id) => {
  const api_url = getapiurl() + "api/view/" + app + "/" + id + "/getPageItem";
  const token = await getAccessToken(app);

  const resp = await axios
    .get(api_url, { headers: { Authorization: token } })
    .then((response) => {
      // If request is good...

      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const getTicker = async (app, id) => {
  const api_url = getapiurl() + "api/view/" + app + "/" + id + "/getPageTicker";
  const token = await getAccessToken(app);

  const resp = await axios
    .get(api_url, { headers: { Authorization: token } })
    .then((response) => {
      // If request is good...

      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const getTabDetails = async (app, id) => {
  const api_url = getapiurl() + "api/view/" + id + "/getTabFullDetail";
  const token = await getAccessToken(app);

  const resp = await axios
    .get(api_url, { headers: { Authorization: token } })
    .then((response) => {
      // If request is good...

      return response;
    })
    .catch((error) => {
      throw error;
    });
  return resp;
};

export const sendOtp = async (api, phone, app, history) => {
  const uri =
    "https://2factor.in/API/V1/" + api + "/SMS/+" + phone + "/AUTOGEN";
  const resp = await axios
    .post(uri)
    .then((response) => {
      // If request is good...

      setOtpSession(response.data.Details);
      let path = "/" + app + "/verify";
      history.push(path);
    })
    .catch((error) => {
      throw error;
    });

  return resp;
};

export const verifyOtp = async (api, sessionKey, otp) => {
  const uri =
    "https://2factor.in/API/V1/" +
    api +
    "/SMS/VERIFY/" +
    sessionKey +
    "/" +
    otp;
  const resp = await axios
    .post(uri)
    .then((response) => {
      // If request is good...

      return response;
    })
    .catch((error) => {
      throw error;
    });

  return resp;
};

export const isLoggedin = () => {
  return InPlayer.Account.isAuthenticated();
};

export const isPremium = (asset_id) => {
  InPlayer.Asset.checkAccessForAsset(asset_id)
    .then((data) => {
      return true;
    })
    .catch((error) => {
      return false;
    });
};
